import { GamificationSeasonService } from "@/services/core/gamification-season.service";

export type {
  CreateSeasonRequest,
  AwardXPRequest,
  LeaderboardFilters,
  SeasonStats,
} from "@/services/core/gamification-season.service";

export class GamificationServiceV2 extends GamificationSeasonService {
  constructor() {
    super('gamification-v2');
  }
}

export const gamificationServiceV2 = new GamificationServiceV2();
